module.exports = __webpack_public_path__ + "assets/img/5_1268_big.25ba990e.jpg";